import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import DrWatsonLargeLogoImage from '../../images/logo/dr-watson-large-logo.svg';
import DrWatsonLargeLogoImageWhite from '../../images/logo/dr-watson-large-logo-white.svg';

const DrWatsonLargeLogo = ({ white = false, className = '' }) => (
    <Link to="/" className={className}>
        <img
            id="dr-watson-large-logo"
            src={white ? DrWatsonLargeLogoImageWhite : DrWatsonLargeLogoImage}
            alt="DR WATSON"
        />
        <i className={`subtitle is-size-4-touch is-size-3-desktop has-text-centered main-slogan ${
            white
                ? 'has-text-white'
                : ''
        }`}
        >
            Our science, your wellbeing
        </i>
    </Link>
);

DrWatsonLargeLogo.propTypes = {
    white: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};

export default DrWatsonLargeLogo;
